import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly-attendance-grid',
  templateUrl: './monthly-attendance-grid.component.html',
  styleUrls: ['./monthly-attendance-grid.component.css']
})
export class MonthlyAttendanceGridComponent implements OnInit {
  title ="View Monthly Attendance"
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  r: any ={};
  mode: any;
  hld_id : any;
  YearList : any 
  TempTableList=[];
  Temp1:any={};
  itemsPerPage:any;
  itemsPerPageChanged:any;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/Monthly Attendance/monthly-attendance-grid/monthly-attendance-grid.component.ts